var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0H1.6C1.17565 0 0.768687 0.168571 0.468629 0.468629C0.168571 0.768687 0 1.17565 0 1.6V3.2C0.00168539 3.47922 0.0764141 3.75314 0.216759 3.99454C0.357105 4.23593 0.558179 4.43639 0.8 4.576V12.8C0.8 13.2243 0.968571 13.6313 1.26863 13.9314C1.56869 14.2314 1.97565 14.4 2.4 14.4H13.6C14.0243 14.4 14.4313 14.2314 14.7314 13.9314C15.0314 13.6313 15.2 13.2243 15.2 12.8V4.576C15.4418 4.43639 15.6429 4.23593 15.7832 3.99454C15.9236 3.75314 15.9983 3.47922 16 3.2V1.6C16 1.17565 15.8314 0.768687 15.5314 0.468629C15.2313 0.168571 14.8243 0 14.4 0ZM1.6 1.6H14.4V3.2H1.6V1.6ZM2.4 12.8V4.8H13.6V12.8H2.4Z",
    fill: "#861DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 6.3999H11.1998V7.9999H4.7998V6.3999Z",
    fill: "#861DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.667fdc14d929bae0380bdaf5f59f5030.svg";
export { ForwardRef as ReactComponent };